<template>
  <v-card>
    <!-- Title -->
    <v-card-title>
      <slot name="title"/>
    </v-card-title>

    <!-- Contents -->
    <v-card-text>
      <!-- 説明文など -->
      <slot/>

      <!-- 支払方法のリスト -->
      <c-payment-list :payments="payments">

        <!-- 支払方法への追加操作 -->
        <template #itemActions="{ payment }">
          <!-- 削除ボタン -->
          <v-btn outlined text color="error" @click="onDelete(payment)">
            削除
          </v-btn>

          <!-- 支払方法への追加操作 -->
          <slot
            name="itemActions"
            :userID="userID"
            :payment="payment"
            :update="update"
          />
        </template>

      </c-payment-list>

      <c-payment-delete-dialog
        v-model="deleteDialog"
        :payment="currentPayment"
        @cancel="deleteDialog = false"
        @delete="onDeleteAction"
      />
    </v-card-text>

    <c-card-errors :errors="errors"/>

    <v-card-actions>
      <!-- 支払方法 追加ボタン -->
      <v-btn color="primary" :to="{name: 'my/newcard'}">
        支払方法を追加
      </v-btn>

      <!-- カードに表示する追加の操作 -->
      <slot name="actions"/>
    </v-card-actions>
  </v-card>
</template>

<script>
import CCardErrors from '@/components/CCardErrors'
import CPaymentList from './CPaymentList'
import CPaymentDeleteDialog from './CPaymentDeleteDialog'

import * as http from '@/libs/http'
import * as api from '@/api'
import { run } from '@/libs/a'

export default {
  name: 'CPaymentListCard',
  components: {
    CCardErrors,
    CPaymentList,
    CPaymentDeleteDialog
  },

  data: () => ({
    // ユーザID
    userID: 0,

    // 支払一覧
    payments: null,

    // エラー情報
    errors: [],

    // エラーダイアログ
    deleteDialog: false,
    currentPayment: null
  }),

  // コンポーネントが作られたとき
  created () {
    run(async () => {
      // ユーザID を取得する
      this.userID = this.getters['user/id']
      if (!this.userID) {
        throw new Error('The user is not logged in.')
      }

      // 支払一覧を読み込む
      await this.loadPaymentList()
    })
  },

  methods: {
    /**
     * 支払一覧を読み込む
     */
    async loadPaymentList () {
      // 支払方法一覧を取得する
      const resp = await api.getUserPayments(this.userID)
      this.payments = resp.data.payments
    },

    /**
     * 操作完了後の更新
     */
    update (payload) {
      return run(async () => {
        if (payload === true) {
          // payload: true の時は一覧を再取得する
          await this.loadPaymentList()
        } else if (payload) {
          // payload: true 以外の値の時はエラー情報として扱う
          this.errors = payload
        } else {
          // payload: false の時は情報に変化ないので何もしない
        }
      })
    },

    /**
     * 削除ボタンが押された
     */
    onDelete (payment) {
      this.deleteDialog = true
      this.currentPayment = payment
    },

    /**
     * 削除ダイアログのアクション
     *
     * @param {Function} failed エラー時に呼び出すコールバック関数
     */
    onDeleteAction (failed) {
      run(async () => {
        // 支払方法を削除する
        const resp = await api.removeUserPayment(this.userID, this.currentPayment.payID)
        if (resp.status !== http.OK) {
          failed(['支払方法の削除に失敗しました'])
          return
        }

        // 表示を更新する
        await this.update(true)

        // ダイアログを閉じる
        this.deleteDialog = false
      })
    }
  }
}
</script>
